import { Faq } from "@/domain/faq.model";
import { IPaginateVueTable } from "@/interfaces/IPaginateVueTable";

export default {
  faqs: (state): IPaginateVueTable<Faq> => state.faqs,
  faq: (state): Faq => state.faq,
  isLoading: (state): boolean => state.isLoading,
  isCreating: (state): boolean => state.isCreating,
  isUpdating: (state): boolean => state.isUpdating,
  isDeleting: (state): boolean => state.isDeleting,
};
